import type { I18nDict, LocaleCode } from './types.ts'
import { ar } from './locales/ar.ts'
import { da } from './locales/da.ts'
import { de } from './locales/de.ts'
import { en } from './locales/en.ts'
import { es } from './locales/es.ts'
import { fi } from './locales/fi.ts'
import { fr } from './locales/fr.ts'
import { it } from './locales/it.ts'
import { ja } from './locales/ja.ts'
import { nb } from './locales/nb.ts'
import { nl } from './locales/nl.ts'
import { pl } from './locales/pl.ts'
import { pt } from './locales/pt.ts'
import { ru } from './locales/ru.ts'
import { sv } from './locales/sv.ts'
import { resolveLocale } from '../storage/languageStore.ts'

const MAP: Record<LocaleCode, I18nDict> = {
  it,
  en,
  es,
  fr,
  de,
  pt,
  ru,
  ja,
  ar,
  nl,
  sv,
  nb,
  da,
  fi,
  pl,
}

let active: LocaleCode = resolveLocale()

function applyDocumentLang(code: LocaleCode): void {
  try {
    document.documentElement.lang = code
    document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr'
  } catch {
    /* ignore */
  }
}

export function setActiveLocale(code: LocaleCode): void {
  active = code
  applyDocumentLang(code)
}

export function getActiveLocale(): LocaleCode {
  return active
}

export function t(key: string): string {
  return MAP[active]?.[key] ?? MAP.en[key] ?? MAP.it[key] ?? key
}

/** Replace `{name}` style placeholders. */
export function tf(key: string, vars: Record<string, string | number>): string {
  let s = t(key)
  for (const [k, v] of Object.entries(vars)) {
    s = s.replaceAll(`{${k}}`, String(v))
  }
  return s
}

export function initI18n(): void {
  active = resolveLocale()
  applyDocumentLang(active)
}
